module.exports = __webpack_public_path__ + "static/media/LogoVitalbookHoriz.ec6bd41b.svg";